// Generic page-chrome behaviors that aren't tied to a specific feature area.

// === sticky panel offset ===
// Keeps cart/checkout summary boxes aligned with the bottom of the fixed header.
function init_sticky_header_offset() {
    function sync() {
        var header = document.querySelector('header.banner.fixed-top');
        if (!header) {
            return;
        }

        var bottom = Math.ceil(header.getBoundingClientRect().bottom);
        document.documentElement.style.setProperty('--zd-sticky-top', bottom + 'px');
    }

    jQuery(window).on('scroll resize', sync);
    sync();
}

// === admin bar scroll state ===
// Adds a class to body when the WP admin bar would scroll off-screen on mobile,
// so the theme can drop the top offset cleanly.
function init_admin_bar_scroll() {
    function sync() {
        if (window.innerWidth > 782) {
            jQuery('body').removeClass('scrolled-past-admin-bar');
            return;
        }

        if (jQuery(window).scrollTop() > 46) {
            jQuery('body').addClass('scrolled-past-admin-bar');
        } else {
            jQuery('body').removeClass('scrolled-past-admin-bar');
        }
    }

    jQuery(window).on('scroll resize', sync);
    sync();
}

// === responsive tabs ===
// jquery.responsiveTabs is registered on the jQuery prototype by the npm
// `responsive-tabs` package, imported from main.js.
function init_responsive_tabs() {
    var $tabs = jQuery('.woocommerce-tabs');
    if (!$tabs.length || typeof $tabs.responsiveTabs !== 'function') return;
    $tabs.responsiveTabs({ startCollapsed: 'accordion' });
}

// === mega menu close ===
// Max Mega Menu can leave expanded submenus (li.mega-toggle-on) after the mobile
// panel closes — especially on real touch devices where touchend/click ordering differs
// from DevTools mobile simulation.
function collapse_mega_submenus_if_mobile_menu_closed() {
    var $wrap = jQuery('#mega-menu-wrap-primary_navigation');
    var $menu = jQuery('#mega-menu-primary_navigation');

    if (!$wrap.length || !$menu.length || $wrap.hasClass('mega-toggle-on')) {
        return;
    }

    $menu.find('li.mega-menu-item').removeClass('mega-toggle-on');

    var api = $menu.data('maxmegamenu');
    if (api && typeof api.hideAllPanels === 'function') {
        api.hideAllPanels();
    }
}

function init_mega_menu() {
    var suppress_click_until = 0;

    function schedule_collapse() {
        window.setTimeout(collapse_mega_submenus_if_mobile_menu_closed, 50);
    }

    jQuery(document).on('touchend', '.mega-toggle-block, .mega-menu-toggle, .mega-close', function() {
        suppress_click_until = Date.now() + 400;
        schedule_collapse();
    });

    jQuery(document).on('click', '.mega-toggle-block, .mega-menu-toggle, .mega-close', function() {
        if (Date.now() < suppress_click_until) {
            return;
        }
        schedule_collapse();
    });
}

// === bootstrap collapse chevron rotation ===
// Any [data-bs-toggle="collapse"] trigger pointing at a Bootstrap .collapse gets
// its child .bi (icon) rotated when the panel opens.
function init_collapse_chevron_rotation() {
    jQuery(document).on('show.bs.collapse', '.collapse', function() {
        var target_id = this.id;
        if (!target_id) return;

        jQuery('[data-bs-toggle="collapse"][href="#' + target_id + '"]')
            .find('.bi')
            .addClass('rotated');
    });

    jQuery(document).on('hide.bs.collapse', '.collapse', function() {
        var target_id = this.id;
        if (!target_id) return;

        jQuery('[data-bs-toggle="collapse"][href="#' + target_id + '"]')
            .find('.bi')
            .removeClass('rotated');
    });
}

// === hide WooCommerce pagination ===
// The theme provides its own pagination/filter UI; the default WC one is unwanted.
function hide_wc_pagination() {
    jQuery('.woocommerce-pagination').hide();
}

export function init() {
    init_sticky_header_offset();
    init_admin_bar_scroll();
    init_responsive_tabs();
    init_mega_menu();
    init_collapse_chevron_rotation();
    hide_wc_pagination();
}
